export const enum TripOverviewPanelType {
  None = 'none',
  TripSummary = 'TripSummary',
  Configuration = 'configuration',
  FerryFilters = 'ferryFilters',
  HotelFilters = 'hotelFilters',
}

export interface TripOverviewNoPanel {
  type: TripOverviewPanelType.None;
}

export interface TripPriceSummaryPreCheckoutPanel {
  type: TripOverviewPanelType.TripSummary;
}

export interface TripOverviewConfigurationPanel {
  type: TripOverviewPanelType.Configuration;
}

export interface TripOverviewFerryFiltersPanel {
  type: TripOverviewPanelType.FerryFilters;
}

export interface TripOverviewHotelFiltersPanel {
  type: TripOverviewPanelType.HotelFilters;
}

export type TripOverviewPanel =
  | TripOverviewNoPanel
  | TripPriceSummaryPreCheckoutPanel
  | TripOverviewConfigurationPanel
  | TripOverviewFerryFiltersPanel
  | TripOverviewHotelFiltersPanel;

export const TRIP_OVERVIEW_NO_PANEL: TripOverviewNoPanel = {
  type: TripOverviewPanelType.None,
};

export const TRIP_PRICE_SUMMARY_PRE_CHECKOUT_PANEL: TripPriceSummaryPreCheckoutPanel =
  {
    type: TripOverviewPanelType.TripSummary,
  };

export const TRIP_OVERVIEW_CONFIGURATION_PANEL: TripOverviewConfigurationPanel =
  {
    type: TripOverviewPanelType.Configuration,
  };

export const TRIP_OVERVIEW_FERRY_FILTERS_PANEL: TripOverviewFerryFiltersPanel =
  {
    type: TripOverviewPanelType.FerryFilters,
  };

export const TRIP_OVERVIEW_HOTEL_FILTERS_PANEL: TripOverviewHotelFiltersPanel =
  {
    type: TripOverviewPanelType.HotelFilters,
  };
